//#region src/locales/ko/stage.yaml
var data = {
	"chat": {
		"actions": { "retry": "다시 시도" },
		"message": { "character-name": {
			"core-system": "코어",
			"you": "당신"
		} },
		"reasoning": "추론",
		"sessions": {
			"title": "대화",
			"new": "+ New",
			"delete": "대화 삭제"
		}
	},
	"render-error": {
		"title": "{renderer}에서 이 모델을 렌더링할 수 없습니다",
		"description": "모델이 선택되었지만 스테이지에 표시할 수 없습니다.",
		"report-description": "{renderer}에서 선택한 모델을 렌더링하지 못했습니다.\n모델 ID: {modelId}\n오류: {error}"
	},
	"message": "듣고 있어요...",
	"send-mode": { "enter": "엔터" },
	"speech-output": {
		"mute": "음성 음소거",
		"unmute": "음소거 해제"
	},
	"operations": {
		"load-models": "모델 불러오기",
		"load-models-status": {
			"loading": "로딩 중",
			"ready": "준비됨"
		}
	},
	"select-a-audio-input": "오디오 입력 선택",
	"select-a-model": "모델 선택",
	"select-a-voice": "음성 선택",
	"viewers": { "debug-menu": {
		"emotions": "감정",
		"emotions-btn": {
			"angry": "화남",
			"awkward": "어색함",
			"happy": "행복함",
			"neutral": "🙂 중립",
			"question": "🤔 질문",
			"sad": "슬픔",
			"surprised": "놀람",
			"think": "🤨 생각"
		},
		"vrm": {
			"camera": "카메라",
			"model": { "title": "모델" }
		}
	} },
	"profile-switcher": {
		"no-profile": "프로필 없음",
		"no-profiles": "아직 프로필 없음",
		"save-as-new": "새로운 프로필로 저장하기",
		"new-profile-name": "프로필 이름",
		"manage": "프로필 관리"
	},
	"promo-banner": { "items": {
		"signin": {
			"watermark": "달",
			"cta": "로그인"
		},
		"build": {
			"watermark": "빌드",
			"fallbackLabel": "빌드 보너스",
			"cta": "작업 보기"
		},
		"coupon": {
			"watermark": "대화",
			"fallbackLabel": "쿠폰",
			"cta": "쿠폰 받기"
		},
		"home": {
			"watermark": "홈",
			"fallbackLabel": "방 테마",
			"title": "봄 테마 업데이트",
			"eventName": "........",
			"cta": "테마 보기"
		}
	} },
	"waiting": "대기 중",
	"websocket-status": {
		"connected": "연결됨",
		"disconnected": "연결 없음",
		"open-settings": "연결 설정 열기"
	}
};
//#endregion
export { data as default };
